const FLOOR_COUNT = 7;
const PARTICLE_COUNT = 10;

// Beautifies the raw backend `step` string for the hologram label while
// keeping any dynamic counts it carries (e.g. "N chunks") — never fabricates
// a status the backend didn't report.
function prettifyStep(raw) {
  if (!raw) return 'Initializing extraction engine...';
  if (raw.startsWith('Starting AI extraction')) return 'Initializing extraction engine...';
  if (raw.startsWith('Extracting text + structure')) return 'Parsing BEP document structure...';
  if (raw.startsWith('Pass 1:')) return raw.replace('Pass 1:', 'Pass 1 — Scanning').replace('Analyzing', '');
  if (raw.startsWith('Pass 2:')) return raw.replace('Pass 2:', 'Pass 2 —');
  if (raw.startsWith('Two-stage extraction')) return raw.replace('Two-stage extraction', 'Two-stage AI verification');
  if (raw.startsWith('Building rules manifest')) return 'Compiling rules manifest...';
  return raw;
}

/** Animated CSS/SVG "hologram" loader shown only while Step 1 (Extract
 * Rules from BEP, including force re-extract) is running. `step` is the
 * live backend status message from bep-status polling. */
export const BepExtractionHologram = ({ step }) => {
  const label = prettifyStep(step);

  return (
    <div className="hologram-card" data-testid="bep-extraction-hologram">
      <div className="hologram-grid-bg" aria-hidden="true" />
      <svg viewBox="0 0 220 236" className="hologram-svg" aria-hidden="true">
        {/* construction crane, static accent */}
        <g stroke="#38bdf8" strokeWidth="1.4" fill="none" opacity="0.45">
          <line x1="186" y1="228" x2="186" y2="26" />
          <line x1="186" y1="30" x2="214" y2="30" />
          <line x1="186" y1="30" x2="162" y2="54" />
          <line x1="209" y1="30" x2="209" y2="46" />
        </g>
        {/* stacked floors — each pulses on a staggered delay, climbing the tower */}
        {Array.from({ length: FLOOR_COUNT }).map((_, i) => {
          const y = 216 - i * 26;
          const delay = `${i * 0.32}s`;
          return (
            <g key={i} className="hologram-floor" style={{ animationDelay: delay }}>
              <rect x="52" y={y - 20} width="96" height="20" fill="none" stroke="#22d3ee" strokeWidth="1.6" />
              <line x1="52" y1={y - 20} x2="44" y2={y - 12} stroke="#60a5fa" strokeWidth="1" />
              <line x1="148" y1={y - 20} x2="156" y2={y - 12} stroke="#60a5fa" strokeWidth="1" />
            </g>
          );
        })}
        {/* rising data-stream particles along both columns */}
        {Array.from({ length: PARTICLE_COUNT }).map((_, i) => (
          <circle
            key={i}
            cx={i % 2 === 0 ? 58 : 142}
            cy="216"
            r="2"
            fill="#67e8f9"
            className="hologram-particle"
            style={{ animationDelay: `${i * 0.42}s`, animationDuration: `${2.4 + (i % 3) * 0.4}s` }}
          />
        ))}
      </svg>
      <div className="hologram-step-label" data-testid="bep-extraction-step-label">
        <span className="hologram-dot" aria-hidden="true" />
        {label}
      </div>
    </div>
  );
};

export default BepExtractionHologram;
